import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { UserService } from 'src/app/core/services/user.service';

@Component({
  selector: 'app-detach-deployment',
  templateUrl: './detach-deployment.component.html',
  styleUrls: ['./detach-deployment.component.scss']
})
export class DetachDeploymentComponent implements OnInit {

  username: string = this.data.userName;
  adminId: string = this.data.adminId;
  deploymentName: string = this.data.deploymentName;
  isUserDetach: boolean = this.data.isUserDetach || false;
  deleteFromCluster: boolean = false;
  isVdi: boolean = this.data.isVdi || false;

  constructor(
    public dialog: MatDialogRef<DetachDeploymentComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      userName: string,
      adminId: string,
      deploymentName: string,
      isUserDetach: boolean,
      isVdi: boolean
    }
  ) { }

  ngOnInit(): void {
  }

  onClose() {
    this.dialog.close(false);
  }

  onSubmit() {
    let detachObj = {
      "userName": this.username,
      "adminId": this.adminId,
      "depName": this.deploymentName,
      "deleteFromCluster": this.deleteFromCluster || false
    }

    this.dialog.close(detachObj);
  }

  deleteFromClusterChange(event: any) {
    this.deleteFromCluster = event.checked;
  }
}
